module.exports = __webpack_public_path__ + "img/Sibiu_f_kl.dec62662.jpg";